import gql from "graphql-tag"

const CREATE_SHIPPING_FEE_MODIFICATION = gql`
  mutation createOrderModificationShippingFees($orderId: ID!, $input: InputOrderModificationShippingFees!) {
    Order {
      createOrderModificationShippingFees(orderId: $orderId, input: $input) {
        ... on OrderModificationShippingFees {
          id
          orderReference
          oldTotals {
            subTotal
            discountTotal
            grandTotal
            taxTotal
          }
          newTotals {
            subTotal
            discountTotal
            grandTotal
            taxTotal
          }
          shippingFees {
            modificationType
          }
        }
      }
    }
  }
`

export default CREATE_SHIPPING_FEE_MODIFICATION
